import BOLayout from "@/layouts/bo"
import RouteGuard from "@/utils/route-guard"
import LazyLoadWrapper from "../lazy-load-wrapper"

const moduleTitle = "module_title.announcement";

const index = {
  path: "announcement",
  title: moduleTitle,
  sidebarProps: {
    key: "1-7",
    logoSrc: "speaker",
    label: moduleTitle,
    link: "/announcement",
    groupingType: "TOOLS",
    order: 7,
  },
  element: (
    <BOLayout>
      <RouteGuard mustAuthenticated>
        <LazyLoadWrapper 
          importFn={() => import("@/pages/announcement/list")} 
        />
      </RouteGuard>
    </BOLayout>
  )
}

export default index